'use strict';

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PropTypes = require('prop-types');
var React = require('react');

module.exports = (_temp = _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }

    _class.prototype.render = function render() {
        var buttonText = this.props.inEditMode && this.props.clickedText ? this.props.clickedText : this.props.text;
        return React.createElement(
            'div',
            { className: this.props.buttonClass, id: 'product-add-to-bag-lg' },
            React.createElement('img', { src: this.props.inEditMode ? "/images/common/icons/ic_checkmark.png" : "/images/common/icons/ic_add_2.png" }),
            buttonText
        );
    };

    return _class;
}(React.Component), _class.propTypes = {
    clickHandler: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
    buttonClass: PropTypes.string.isRequired,
    inEditMode: PropTypes.bool.isRequired
}, _temp);


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/bagbutton.js
// module id = 829
// module chunks = 0